/** HR admin codes นอกเหนือจากฝ่าย HR (เทียบเท่า 012539) */
const EVAL_HR_SUPER_CODES = new Set(['012539', '001005']);

function org(emp) {
  return emp?.organization || {};
}

/** ฝ่าย HR (level4/level5) หรือรหัสพิเศษ — เห็นข้อมูลประเมินทั้งหมด */
export function isEvaluationHr(emp) {
  if (!emp) return false;
  if (EVAL_HR_SUPER_CODES.has(String(emp.employeeCode || '').trim())) return true;
  const o = org(emp);
  return o.level4 === 'ทรัพยากรบุคคล' || o.level5 === 'ทรัพยากรบุคคล';
}

/** ผู้ประเมินที่ถูกกำหนดใน mapping เท่านั้นที่เริ่ม/ส่งประเมินได้ */
export function isAssignedEvaluator(row, actor) {
  if (!row || !actor) return false;
  if (row.evaluatorId != null && actor.employeeId != null) {
    if (String(row.evaluatorId) === String(actor.employeeId)) return true;
  }
  const rowCode = String(row.evaluatorCode || '').trim();
  const actorCode = String(actor.employeeCode || '').trim();
  return Boolean(rowCode && actorCode && rowCode === actorCode);
}

/** เมนู HR-only ในกลุ่มประเมิน (ทดลองงานทั้งหมด) — HR + IT Dev */
export function canSeeEvalHrMenus(emp) {
  if (isEvaluationHr(emp)) return true;
  return org(emp).level5 === 'IT Development';
}
